// GraphQL-SSE link for Apollo subscriptions (plan: graphql-sse). Subscriptions
// stream over Server-Sent Events from the Go backend; the access token is sent
// as a bearer header so @hasPermission directives apply.
import { ApolloLink, Observable, type FetchResult } from '@apollo/client';
import { print } from 'graphql';
import { createClient, type Client } from 'graphql-sse';

import { getAccessToken } from './auth';

const sseUri =
  (import.meta.env.VITE_SSE_URL as string | undefined) ??
  (import.meta.env.VITE_GRAPHQL_URL as string | undefined) ??
  '/graphql';

export class SSELink extends ApolloLink {
  private client: Client;

  constructor() {
    super();
    this.client = createClient({
      url: sseUri,
      headers: (): Record<string, string> => {
        const token = getAccessToken();
        return token ? { authorization: `Bearer ${token}` } : {};
      },
    });
  }

  request(operation: Parameters<ApolloLink['request']>[0]) {
    return new Observable<FetchResult>((sink) => {
      return this.client.subscribe(
        { ...operation, query: print(operation.query) },
        {
          next: (value) => sink.next(value as FetchResult),
          complete: sink.complete.bind(sink),
          error: sink.error.bind(sink),
        },
      );
    });
  }
}
